import {
  LEGEND_OPEN,
  LEGEND_CLOSE,
  TOGGLE_LEGEND,
} from '../common/actionTypes';

export const legendOpen = () => ({
  type: LEGEND_OPEN,
});

export const legendClose = () => ({
  type: LEGEND_CLOSE,
});

export const toggleLegend = () => ({
  type: TOGGLE_LEGEND,
});



// WEBPACK FOOTER //
// ./map/actions/legendActions.js